import { NoteButton } from "@components/tabsButtons/TabsButtons";
import { Project } from "@typedefs/interfaces";
import { TranslationKey } from "@typedefs/modulesInterfaces";
import { useAppSelector } from "@app/hooks";
import { useLocation } from "react-router-dom";
import { selectMapSaveStatusMessage } from "@app/features/mapSaveStatus/mapSaveStatusSlice";
import { useMemo } from "react";
import TranslatableText from "@components/translations/TranslatableText";
import classNames from "classnames";
import BintactStatusMessage from "@pages/bintactBuilder/BintactStatusMessage";
import ProjectAreaBanner from "./ProjectAreaBanner";
import ProjectNotificationsBanner from "./ProjectNotificationsBanner";

interface ProjectContentHeaderProps {
  project: Project | null | undefined;
  includeNotes: boolean;
  title: TranslationKey;
}

const ProjectContentHeader = ({
  project,
  includeNotes,
  title,
}: ProjectContentHeaderProps) => {
  const { pathname } = useLocation();
  const isInActivities = useMemo(
    () => pathname.includes("/activities"),
    [pathname]
  );
  const isProjectCreated = useMemo(() => project?.id && project?.id !== 0, [project?.id]);

  const projectIdStr = project?.id?.toString() ?? null;
  const mapSaveStatusMessage = useAppSelector((state) =>
    projectIdStr ? selectMapSaveStatusMessage(state, projectIdStr) : null
  );

  return (
    <header
      className={classNames("pos-relative pb-2 bb-1 d-flex f-column", {
        "pe-3": includeNotes,
      })}
    >
      <h2
        className="fs-14 ff-medium-ext module-header w-fit"
      >
        <TranslatableText translationKey={title} />
      </h2>

      {isProjectCreated && mapSaveStatusMessage && (
        <BintactStatusMessage
          statusMessage={mapSaveStatusMessage}
          showContainer={false}
          margin="top"
        />
      )}
      {isInActivities && isProjectCreated && (
        <ProjectAreaBanner project={project ?? null} />
      )}
      {/* {isProjectCreated && <ProjectNotificationsBanner project={project} />} */}
      <AbsoluteElements
        project={project}
        includeNotes={includeNotes && !!project}
      />
    </header>
  );
};

const AbsoluteElements = ({
  project,
  includeNotes,
}: {
  project: Project | null | undefined;
  includeNotes: boolean;
}) => {
  return (
    <>
      <div
        className="pos-absolute d-flex align-items-center h-100"
        style={{ top: 0, left: "98%" }}
      >
        {includeNotes && <NoteButton />}
      </div>
      <div className="module-number header-number ff-light-ext">
        {project?.id ?? project?.id}
      </div>
    </>
  );
};

export default ProjectContentHeader;
